document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') return;
  const input = form.querySelector('input[name="q"]');
  if (!(input instanceof HTMLInputElement) || !input.value.trim()) return;
  let type = form.querySelector('input[name="type"]');
  if (!type) {
    type = document.createElement('input');
    type.type = 'hidden';
    type.name = 'type';
    form.append(type);
  }
  type.value = 'product';
}, true);
